(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["absina-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('absina-legal-guarantee')) {
    customElements.define('absina-legal-guarantee', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('dialog');

        this.querySelector('[data-guarantee-open]').addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        }, options);

        this.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close(), options);

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["absina-newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('absina-newsletter-signup')) {
    customElements.define('absina-newsletter-signup', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.input = this.form.querySelector('input[type="email"]');
        this.fields = this.querySelector('[data-newsletter-fields]');
        this.success = this.querySelector('[data-newsletter-success]');
        this.error = this.querySelector('[data-newsletter-error]');
        this.button = this.form.querySelector('.absina-newsletter-form__submit');
        this.label = this.querySelector('[data-newsletter-submit-label]');
        this.defaultLabel = this.label.textContent;
        this.defaultTitle = this.querySelector('[data-newsletter-title]').textContent;
        this.defaultMessage = this.querySelector('[data-newsletter-message]').textContent;
        this.loading = this.querySelector('[data-newsletter-loading]');
        this.standard = this.querySelector('[data-newsletter-standard]');
        this.edit = this.querySelector('[data-newsletter-edit]');
        this.edit.hidden = false;
        this.busy = false;
        this.setBusy(false);
        this.form.addEventListener('submit', event => this.submit(event), { ...options, capture: true });
        this.edit.addEventListener('click', () => this.editEmail(), options);
        window.addEventListener('pageshow', () => this.setBusy(false), options);
        const pending = this.readPending();
        const target = window.location.hash.slice(1);
        if (!this.success.hidden && (!target || target === this.form.id)) {
          this.showSuccess(this.input.value || pending?.email || '', false);
          this.forgetPending();
          this.reveal();
        } else if (!this.success.hidden) {
          this.reset();
          this.input.value = '';
        } else if (!this.error.hidden && target === this.form.id) {
          if (pending?.email) this.input.value = pending.email;
          this.forgetPending();
          this.reveal();
        }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        clearTimeout(this.nativeTimer);
      }
      readPending() {
        try {
          const item = JSON.parse(sessionStorage.getItem('absina-newsletter-pending') || 'null');
          if (item && Date.now() - item.time >= 600000) this.forgetPending();
          return item && item.id === this.form.id && Date.now() - item.time < 600000 ? item : null;
        } catch { return null; }
      }
      remember(email) {
        try { sessionStorage.setItem('absina-newsletter-pending', JSON.stringify({ id: this.form.id, email, path: location.pathname, time: Date.now() })); } catch {}
      }
      forgetPending() {
        try { sessionStorage.removeItem('absina-newsletter-pending'); } catch {}
      }
      setBusy(busy) {
        this.busy = busy;
        this.form.setAttribute('aria-busy', String(busy));
        this.button.disabled = busy;
        this.standard.disabled = busy;
        this.input.readOnly = busy;
        this.label.textContent = busy ? this.dataset.loadingLabel : this.defaultLabel;
        this.loading.hidden = !busy;
      }
      reset() {
        this.success.hidden = true;
        this.error.hidden = true;
        this.standard.hidden = true;
        this.fields.hidden = false;
        this.dataset.state = 'editing';
        this.input.removeAttribute('aria-invalid');
      }
      editEmail() {
        const email = this.querySelector('[data-newsletter-email]').textContent;
        this.reset();
        this.forgetPending();
        this.input.value = email;
        this.input.focus({ preventScroll: true });
      }
      showSuccess(email, focus = true, received = false) {
        this.setBusy(false);
        this.fields.hidden = true;
        this.error.hidden = true;
        this.standard.hidden = true;
        this.success.hidden = false;
        this.dataset.state = received ? 'received' : 'success';
        this.querySelector('[data-newsletter-title]').textContent = received ? this.dataset.receivedTitle : this.defaultTitle;
        this.querySelector('[data-newsletter-message]').textContent = received ? this.dataset.receivedText : this.defaultMessage;
        this.querySelector('[data-newsletter-email]').textContent = email;
        this.querySelector('[data-newsletter-address]').hidden = !email;
        if (email) this.input.value = email;
        if (focus) this.success.focus({ preventScroll: true });
      }
      showError(message, standard = false) {
        this.setBusy(false);
        this.success.hidden = true;
        this.fields.hidden = false;
        this.error.textContent = message;
        this.error.hidden = false;
        this.standard.hidden = !standard;
        this.dataset.state = 'error';
        this.error.focus({ preventScroll: true });
      }
      async reveal() {
        const disclosure = this.closest('details');
        if (disclosure) disclosure.open = true;
        const drawer = this.closest('cart-drawer');
        if (drawer) {
          await customElements.whenDefined('cart-drawer');
          if (drawer.isConnected) await drawer.show();
        }
        const result = this.success.hidden ? this.error : this.success;
        result.focus({ preventScroll: true });
        if (!drawer && !this.closest('absina-newsletter-widget')) {
          const rect = result.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) result.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }
      async submit(event) {
        if (this.busy) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const email = this.input.value.trim();
        this.input.value = email;
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const protectedForm = this.form.dataset.captchaBound === 'true'
          || !!this.form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"]')
          || typeof window.Shopify?.captcha?.protect === 'function';
        if (event.submitter === this.standard || protectedForm || !window.fetch || !window.DOMParser) {
          this.remember(email);
          this.setBusy(true);
          this.nativeTimer = setTimeout(() => {
            if (this.isConnected && this.busy) this.showError(this.dataset.errorLabel);
          }, 30000);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        const body = new URLSearchParams();
        for (const [key, value] of new FormData(this.form)) body.append(key, value);
        body.delete('return_to');
        this.reset();
        this.setBusy(true);
        this.request = new AbortController();
        const timeout = setTimeout(() => this.request.abort(), 20000);
        try {
          const response = await fetch(this.form.action, {
            method: 'POST', body, credentials: 'same-origin',
            headers: { Accept: 'text/html' }, signal: this.request.signal
          });
          const resultURL = new URL(response.url);
          if (resultURL.origin !== window.location.origin || /\/challenge(?:\/|$)/.test(resultURL.pathname)) {
            this.showError(this.dataset.fallbackLabel, true);
            return;
          }
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const form = page.getElementById(this.form.id);
          const accepted = form?.querySelector('[data-newsletter-success]:not([hidden])');
          const rejected = form?.querySelector('[data-newsletter-error]:not([hidden])');
          if (response.ok && accepted) {
            this.showSuccess(email);
            this.forgetPending();
          } else if (rejected) {
            this.showError(rejected.textContent.trim());
          } else if (response.ok && form) {
            this.showSuccess(email, true, true);
            this.forgetPending();
          } else {
            this.showError(response.ok ? this.dataset.fallbackLabel : this.dataset.errorLabel, response.ok);
          }
        } catch {
          if (this.isConnected) this.showError(this.dataset.errorLabel);
        } finally {
          clearTimeout(timeout);
          if (this.isConnected) this.setBusy(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
